import React, { Component } from 'react';
import logo from "../assets/svg/logoLumio.svg";
import { Link } from "react-router-dom";


export default class FooterInner extends Component {
  render() {
    return (
      <div className="App-footer-inner">
        <div className="row">
          <div className="col-xs-12 col-lg-10 col-lg-push-1 ">
            <div className="row">
              <div className="col-xs-12 col-md-12 App-footer-logo">
                <img src={logo} alt="Lumio.id"/>
              </div>
              <div className="col-xs-12 col-md-6 App-footer-contact">
                <p>
                  <strong>PT. Lumio Inovasi Technology </strong><br/>
                  Jl. Kampung Bali Kecil I No 33D <br/>
                  Tanah Abang, Jakarta Pusat <br/>
                  JAKARTA 10250 <br/>
                  info@lumio.id
                </p>
              </div>
              <div className="col-xs-12 col-md-6 ">
                <div className="row">
                  <div className="col-xs-6 col-md-6">
                    <strong>Navigation</strong>
                    <ul>
                      <li ><Link to="/">Home</Link></li>
                      <li ><Link to="/features">Features</Link></li>
                      <li ><Link to="/use-case">Use Case</Link></li>
                      {/*<li ><Link to="/pricing">Pricing</Link></li>*/}
                      {/*<li ><Link to="/about">About</Link></li>*/}
                    </ul>
                  </div>
                  {/*<div className="col-xs-6 col-md-6">*/}
                    {/*<strong>Developer</strong>*/}
                    {/*<ul>*/}
                      {/*<li><a href="#">Documentation</a></li>*/}
                      {/*<li><a href="#">API</a></li>*/}
                      {/*<li><a href="#">SDK</a></li>*/}
                      {/*<li><a href="#">Hardware</a></li>*/}
                    {/*</ul>*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FooterInner.js